import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import {
  NBA_LEAGUES,
  NBA_LEAGUES_JOIN_LEAGUESLUG,
} from '@sorare/core/src/constants/__generated__/routes';

import { LeagueMembers } from '@sorare/us-sports/src/components/leagues/LeagueMembers';

import { useLayoutData } from '../layout';

const Members = () => {
  const { league, isMember, fetchMore } = useLayoutData();
  return (
    <LeagueMembers
      league={league}
      sport={Sport.NBA}
      afterLeaveRoute={NBA_LEAGUES}
      inviteRoute={NBA_LEAGUES_JOIN_LEAGUESLUG}
      isMember={isMember}
      loadMore={() => {
        fetchMore({
          variables: {
            offset: league?.members.length,
          },
        });
      }}
    />
  );
};

export default Members;
